import { activityTypeForActivityTypeId } from '@shared/constants';

export const moduleName = 'activities';

export const selectedActivityTypeFilters = Object.keys(
  activityTypeForActivityTypeId,
).reduce((acc, key) => ({ ...acc, [key]: true }), {});

export const PERSONAL_ACTIVITY = 'PERSONAL_ACTIVITY';

export const UNIT_ACTIVITY = 'UNIT_ACTIVITY';

export const selectedActivityFilters = Object.freeze({
  ...selectedActivityTypeFilters,
  [UNIT_ACTIVITY]: true,
  [PERSONAL_ACTIVITY]: true,
});

export const ITEMS_PER_PAGE_OPTIONS = [16, 36, 56];

/**
 * For users without any of these positions, they can only add people
 * that belong to any of their subunits to the activities.
 */
export const newPositionsAllowedToAddAnyPeople = [
  'Cubmaster',
  'Chartered Organization Rep.',
  'Council Unit Representative',
  'COR/CUR Delegate',
  'Committee Chair',
  'Committee Chairman',
  'Unit Support',
  'Unit Outdoors / Activities Chair',
  'Assistant Cubmaster',
  'Scoutmaster',
  'Venturing Crew Advisor',
  'Skipper',
  'Key 3 Delegate',
  'Activity Approver/Creator/Remover/Editor',
  'Scout Executive',
  'Council Admin',
];

export const CAMPS_SEARCH_REGEX = /^[ a-zA-Z0-9_\-:;@%&/']*$/;

export const EAGLE_PROJECT_ACTIVITY_TYPE = 5;
export const EAGLE_PROJECT_ACTIVITY_HOURS_TYPE_ID = 10;
